//请自行添加语言资源
const leadtime = {

  msg:{

  }
};
export default leadtime



// WEBPACK FOOTER //
// ./src/page/md/leadtime/lang/leadtime.zh.js